import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopTasksProps extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean;
}

export default function StopTasks({ isSelected = false, style, onClick }: StopTasksProps) {
  return (
    <SvgIcon onClick={onClick} viewBox="0 0 24 24" style={{ width: `24px`, height: `24px`, ...(style ?? {}) }}>
      <g>
        {isSelected ? (
          <>
            <path
              d="M6.06208 1.21629L6.07434 1.2169H6.08661H21.3266H21.339L21.3514 1.21628C22.0893 1.17967 22.728 1.7488 22.7707 2.49698V18.0801C22.7279 18.822 22.0957 19.3975 21.3512 19.361L21.3389 19.3604H21.3266H6.08661H6.07422L6.06183 19.361C5.32394 19.3976 4.68524 18.8284 4.64258 18.0803V2.49712C4.68533 1.75525 5.31755 1.17971 6.06208 1.21629Z"
              fill={RoutalPalette.primary40}
              stroke={RoutalPalette.primary40}
            />
            <path
              d="M18.8285 22.9904H3.07478C1.96678 22.9904 1.07031 22.0918 1.07031 20.9812V3.1604"
              stroke={RoutalPalette.primary40}
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M9.16992 10.0564L12.4335 13.5499L18.2354 7.33032"
              stroke={RoutalPalette.neutral00}
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        ) : (
          <>
            <path
              d="M6.04981 1.46575L6.0682 1.46665H6.08661H21.3266H21.3452L21.3638 1.46573C21.9623 1.43603 22.4824 1.89647 22.5207 2.50423V18.0723C22.4822 18.6757 21.9669 19.1407 21.3634 19.111L21.3451 19.1101H21.3266H6.08661H6.06802L6.04944 19.111C5.45096 19.1407 4.93089 18.6803 4.89258 18.0725V2.50444C4.93102 1.90112 5.44639 1.4361 6.04981 1.46575Z"
              stroke={RoutalPalette.neutral60}
              fill="none"
              strokeWidth="1.5"
            />
            <path
              d="M18.8285 22.9902H3.07478C1.96678 22.9902 1.07031 22.0916 1.07031 20.9809V3.16016"
              stroke={RoutalPalette.neutral60}
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M9.16992 10.0562L12.4335 13.5497L18.2354 7.33008"
              stroke={RoutalPalette.neutral60}
              fill="none"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )}
      </g>
    </SvgIcon>
  );
}
